import React, { useState, useEffect } from 'react';
import '../style.sass';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { InputTypeAndroid} from 'components/Forms/InputType';
import { useForm } from "react-hook-form";
import SelectType from 'components/Forms/Select';

export function DataCard(props) {
    const {
        setAddCard,
        addCard,
        nextPage
    } = props;

    let meses = [
        { "id": 0, "name": "Enero", "numero": "01" },
        { "id": 1, "name": "Febrero", "numero": "02" },
        { "id": 2, "name": "Marzo", "numero": "03" },
        { "id": 3, "name": "Abril", "numero": "04" },
        { "id": 4, "name": "Mayo", "numero": "05" },
        { "id": 5, "name": "Junio", "numero": "06" },
        { "id": 6, "name": "Julio", "numero": "07" },
        { "id": 7, "name": "Agosto", "numero": "08" },
        { "id": 8, "name": "Septiembre", "numero": "09" },
        { "id": 9, "name": "Octubre", "numero": "10" },
        { "id": 10, "name": "Noviembre", "numero": "11" },
        { "id": 11, "name": "Diciembre", "numero": "12" }];

    const fecha = new Date();
    const ano = fecha.getFullYear();
    let anios = [];
    for (let index = 0; index <= 10; index++) {
        anios.push({ "id": 0, "numero": ano + index });
    }

    //- valores para agregar tarjeta
    const [inputNumberCard, setInputNumberCard] = useState('');
    const [inputTitularT, setInputTitularT] = useState('');
    const [expiry, setExpiry] = useState('');
    const [inputCvc, setInputCvc] = useState('');
    const [inputAnio, setInputAnio] = useState('');
    const [inputMes, setInputMes] = useState('');
    const [inputNameF, setInputNameF] = useState();

    const [lengthCvv, setLengthCvv] = useState(3);
    const [lengthPan, setLengthPan] = useState(16);

    useEffect(() => {
        if (addCard) {
            setInputNumberCard(addCard.cardNumber);
            setInputTitularT(addCard.titular);
            setInputCvc(addCard.cvc);
            setInputAnio(addCard.anio);
            setInputMes(addCard.mes);
            setExpiry(`${inputMes}/${inputAnio}`);
        }
    }, [])

    const [datosBancarios, setDatosBancarios] = useState(addCard);
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            cardNumber: datosBancarios.cardNumber,
            titular: datosBancarios.titular,
            mes: datosBancarios.mes,
            anio: datosBancarios.anio,
            cvc: String(datosBancarios.cvc),
        }
    })

    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);
    const sendFormInformacionBancaria = data => {
        setDatos({
            "cardNumber": data.cardNumber,
            "titular": data.titular,
            "mes": data.mes,
            "anio": data.anio,
            "cvc": String(data.cvc),
        })
        SetReturnForm(true);
    }

    // al recibir data del formulario se guarda en variable datos bancarios
    useEffect(() => {
        if (returnForm) {
            setDatosBancarios(datos);
            setAddCard(datos);
            SetReturnForm(false);
            setInputNameF('titular');
            nextPage();
        }
    }, [returnForm])

    const valNumero = {
        required: 'Campo obligatorio',
        minLength: {
            value: lengthPan,
            message: `Faltan dígitos. Deben ser ${lengthPan} dígitos`
        },
        maxLength: {
            value: lengthPan,
            message: `No debe contener más de ${lengthPan} dígitos`
        },
        pattern: {
            value: /[0-9]{15,16}/,
            message: 'El formato de la tarjeta es inválido'
        }
    };
    const valTitular = {
        required: 'Campo obligatorio',
        minLength: {
            value: 6,
            message: 'El nombre del titular al menos debe de contener 6 carácteres'
        }
    };
    const valCvc = {
        required: 'Campo obligatorio',
        minLength: {
            value: 3,
            message: 'El cvv no debe ser menor a 3 dígitos'
        },
        maxLength: {
            value: 4,
            message: 'El cvv no debe ser mayor a 4 dígitos.'
        },
        pattern: {
            value: /[0-9]{3,4}/,
            message: 'El formato de la tarjeta es inválido'
        }
    };
    const valMes = {
        required: 'Campo obligatorio',
    };
    const valAnio = {
        required: 'Campo obligatorio',
    };

    const handleFocusChange = (e) => {
        setInputNameF(e.target.name);
    }
    const onChangeMes = (e) => {
        let selectedMonth = e.target.value;
        setInputMes(selectedMonth);
        validateMontA(selectedMonth);
    }
    const onChangeAnio = (e) => {
        let selectedYear = e.target.value;
        setInputAnio(selectedYear);
        validateMontActualYear(selectedYear);
    }

    const validateMontActualYear = (value) => {
        let anio = Number(value);
        let actualMonth = fecha.getMonth();
        if (ano === anio) {
            if (Number(inputMes) < (actualMonth + 1)) {
                setInputMes(meses[actualMonth].numero);
                document.querySelector('#mes').selectedIndex = Number(meses[actualMonth].numero);
            }
        }
    }

    const validateMontA = (value) => {
        let selectMonto = Number(value);
        let actualMonth = fecha.getMonth();
        if (ano === Number(inputAnio)) {
            if (Number(selectMonto) < (actualMonth + 1)) {
                setInputMes(meses[actualMonth].numero);
                document.querySelector('#mes').selectedIndex = Number(meses[actualMonth].numero);
            }
        }
    }

    useEffect(() => {
        if (inputMes) {
            setExpiry(inputMes);
            if (inputMes && inputAnio) {
                setExpiry(`${inputMes}/${inputAnio}`);
            }
        }
    }, [inputMes, inputAnio])

    // valida largo del CVV 
    const [textCvv, setTextCvv] = useState('El CVV son 3 números y se localizan en la parte posterior de tu tarjeta.')
    useEffect(() => {
        let numCard = String(inputNumberCard);
        if (numCard?.length >= 1) {
            if (numCard.substr(0, 2) === "34" || numCard.substr(0, 2) === "37") {
                setLengthCvv(4);
                setLengthPan(15);
                setTextCvv('El CVV son 4 números y se localizan en la parte frontal de tu tarjeta.');
                if (numCard?.length >= 16) {
                    setInputNumberCard(inputNumberCard.substr(0, 15));
                }
            } else {
                if (inputCvc?.length >= 3) {
                    setInputCvc(inputCvc.substr(0, 3));
                    setLengthCvv(3);
                    setLengthPan(16);
                    setTextCvv('El CVV son 3 números y se localizan en la parte posterior de tu tarjeta.');
                } else {
                    setLengthCvv(3);
                    setLengthPan(16);
                    setTextCvv('El CVV son 3 números y se localizan en la parte posterior de tu tarjeta.');
                }
            }
        }
    }, [inputCvc, inputNumberCard])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value;
            clearErrors(valu);
            reset({ valu }, {
                keepErrors: false,
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    return (
        <>
            <div className="contenedorGeneral">

                <Cards
                    number={inputNumberCard}
                    name={inputTitularT}
                    expiry={expiry}
                    cvc={inputCvc}
                    focused={inputNameF}
                    placeholders={{
                        name: 'Nombre del Titular'
                    }}
                />

                <form className="formCardBank" onSubmit={handleSubmit(sendFormInformacionBancaria)}>
                    <p>Llena los siguientes datos tal cual aparecen en tu tarjeta.</p>

                    <InputTypeAndroid
                        type="text"
                        name="cardNumber"
                        id="cardNumber"
                        placeholder="Número de tarjeta"
                        refs={register(valNumero)}
                        autocomplete='credit-card'
                        setNumero={setInputNumberCard}
                        numero={inputNumberCard}
                        // value={inputNumberCard}
                        errorMessage={errors.cardNumber && errors.cardNumber.message}
                        pattern={'number'}
                        minLength={lengthPan}
                        maxLength={lengthPan}
                        max="9999999999999"
                        focus={handleFocusChange}
                        // click={() => resetErrors('cardNumber')}
                    />
                    <InputTypeAndroid
                        type="text"
                        name="titular"
                        id="titular"
                        placeholder="Nombre del titular"
                        refs={register(valTitular)}
                        autocomplete='titular'
                        setNumero={setInputTitularT}
                        numero={inputTitularT}
                        errorMessage={errors.titular && errors.titular.message}
                        pattern={'textOnly'}
                        focus={handleFocusChange}
                        // click={() => resetErrors('titular')}
                    />

                    <div className="grupoSelect">
                        <SelectType className="w25"
                            type="text"
                            name="mes"
                            id="mes"
                            placeholder="Mes"
                            refs={register(valMes)}
                            options={meses}
                            errorMessage={errors.mes && errors.mes.message}
                            change={onChangeMes}
                        />

                        <SelectType className="w25"
                            type="text"
                            name="anio"
                            id="anio"
                            placeholder="Año"
                            refs={register(valAnio)}
                            options={anios}
                            errorMessage={errors.anio && errors.anio.message}
                            change={onChangeAnio} />
                    </div>

                    <div className="boxCvv">
                        <InputTypeAndroid
                            type="text"
                            name="cvc"
                            id="cvc"
                            placeholder="CVV"
                            refs={register(valCvc)}
                            autocomplete='cvc'
                            setNumero={setInputCvc}
                            numero={inputCvc}
                            pattern={'number'}
                            errorMessage={errors.cvc && errors.cvc.message}
                            maxLength={lengthCvv}
                            minLength={lengthCvv}
                            className="w25"
                            focus={handleFocusChange}
                            // click={() => resetErrors('cvc')}
                        />

                        <span className="ayuda tooltip bottom">
                            <span className="tiptext">{textCvv}</span>
                        </span>
                    </div>

                    {/* <div className="boxInputGuardar">
                        <input className="inputG" type="checkbox" id="save" name="save"></input>
                        <label htmlFor="save" className="labelG">Guardar tarjeta para futuros pagos</label>
                    </div> */}

                    <div className="boxBtnFinalizar">
                        <button className="btnFinalizarCard">Siguiente</button>
                    </div>
                </form>
            </div>
        </>
    )
}


export function DataCardUpdate(props) {
    const {
        setAddCard,
        addCard,
        nextPage
    } = props;

    let meses = [
        { "id": 0, "name": "Enero", "numero": "01" },
        { "id": 1, "name": "Febrero", "numero": "02" },
        { "id": 2, "name": "Marzo", "numero": "03" },
        { "id": 3, "name": "Abril", "numero": "04" },
        { "id": 4, "name": "Mayo", "numero": "05" },
        { "id": 5, "name": "Junio", "numero": "06" },
        { "id": 6, "name": "Julio", "numero": "07" },
        { "id": 7, "name": "Agosto", "numero": "08" },
        { "id": 8, "name": "Septiembre", "numero": "09" },
        { "id": 9, "name": "Octubre", "numero": "10" },
        { "id": 10, "name": "Noviembre", "numero": "11" },
        { "id": 11, "name": "Diciembre", "numero": "12" }];

    const fecha = new Date();
    const ano = fecha.getFullYear();
    let anios = [];
    for (let index = 0; index <= 10; index++) {
        anios.push({ "id": 0, "numero": ano + index });
    }

    //- valores para agregar tarjeta
    const [inputNumberCard, setInputNumberCard] = useState('');
    const [inputTitularT, setInputTitularT] = useState('');
    const [expiry, setExpiry] = useState('');
    const [inputCvc, setInputCvc] = useState('');
    const [inputAnio, setInputAnio] = useState('');
    const [inputMes, setInputMes] = useState('');
    const [inputNameF, setInputNameF] = useState();

    const [lengthCvv, setLengthCvv] = useState(3);
    const [lengthPan, setLengthPan] = useState(16);
    const [datosBancarios, setDatosBancarios] = useState(addCard);

    useEffect(() => {
        if (addCard) {
            setInputNumberCard(addCard.cardNumber);
            setInputTitularT(addCard.titular);
            setInputAnio(addCard.anio);
            setInputMes(addCard.mes);
            setExpiry(`${inputMes}/${inputAnio}`);
            setDatosBancarios(addCard)

            document.querySelector("#mes").value = addCard.mes
            document.querySelector("#anio").value = addCard.anio
        }
    }, [addCard])

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            cardNumber: datosBancarios.cardNumber,
            titular: datosBancarios.titular,
            mes: datosBancarios.mes,
            anio: datosBancarios.anio
        }
    })


    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);
    const sendFormInformacionBancaria = data => {
        setDatos({
            "titular": data.titular,
            "mes": data.mes,
            "anio": data.anio
        })
        SetReturnForm(true);
    }

    // al recibir data del formulario se guarda en variable datos bancarios
    useEffect(() => {
        if (returnForm) {
            setDatosBancarios(datos);
            setAddCard(datos);
            SetReturnForm(false);
            setInputNameF('titular');
            nextPage();
        }
    }, [returnForm])

    const valNumero = {};
    const valTitular = {
        required: 'Campo obligatorio',
        minLength: {
            value: 6,
            message: 'El nombre del titular al menos debe de contener 6 carácteres'
        }
    };
    const valCvc = {
        required: 'Campo obligatorio',
        minLength: {
            value: 3,
            message: 'El cvv no debe ser menor a 3 dígitos'
        },
        maxLength: {
            value: 4,
            message: 'El cvv no debe ser mayor a 4 dígitos.'
        },
        pattern: {
            value: /[0-9]{3,4}/,
            message: 'El formato de la tarjeta es inválido'
        }
    };
    const valMes = {
        required: 'Campo obligatorio',
    };
    const valAnio = {
        required: 'Campo obligatorio',
    };

    const handleFocusChange = (e) => {
        setInputNameF(e.target.name);
    }
    const onChangeMes = (e) => {
        let selectedMonth = e.target.value;
        setInputMes(selectedMonth);
        validateMontA(selectedMonth);
    }
    const onChangeAnio = (e) => {
        let selectedYear = e.target.value;
        setInputAnio(selectedYear);
        validateMontActualYear(selectedYear);
    }

    const validateMontActualYear = (value) => {
        let anio = Number(value);
        let actualMonth = fecha.getMonth();
        if (ano === anio) {
            if (Number(inputMes) < (actualMonth + 1)) {
                setInputMes(meses[actualMonth].numero);
                document.querySelector('#mes').selectedIndex = Number(meses[actualMonth].numero);
            }
        }
    }

    const validateMontA = (value) => {
        let selectMonto = Number(value);
        let actualMonth = fecha.getMonth();
        if (ano === Number(inputAnio)) {
            if (Number(selectMonto) < (actualMonth + 1)) {
                setInputMes(meses[actualMonth].numero);
                document.querySelector('#mes').selectedIndex = Number(meses[actualMonth].numero);
            }
        }
    }

    useEffect(() => {
        if (inputMes) {
            setExpiry(inputMes);
            if (inputMes && inputAnio) {
                setExpiry(`${inputMes}/${inputAnio}`);
            }
        }
    }, [inputMes, inputAnio])

    // valida largo del CVV 
    const [textCvv, setTextCvv] = useState('El CVV son 3 números y se localizan en la parte posterior de tu tarjeta.')
    useEffect(() => {
        let numCard = String(inputNumberCard);
        if (numCard?.length >= 1) {
            if (numCard.substr(0, 2) === "34" || numCard.substr(0, 2) === "37") {
                setLengthCvv(4);
                setLengthPan(15);
                setTextCvv('El CVV son 4 números y se localizan en la parte frontal de tu tarjeta.');
                if (numCard?.length >= 16) {
                    setInputNumberCard(inputNumberCard.substr(0, 15));
                }
            } else {
                if (inputCvc?.length >= 3) {
                    setInputCvc(inputCvc.substr(0, 3));
                    setLengthCvv(3);
                    setLengthPan(16);
                    setTextCvv('El CVV son 3 números y se localizan en la parte posterior de tu tarjeta.');
                } else {
                    setLengthCvv(3);
                    setLengthPan(16);
                    setTextCvv('El CVV son 3 números y se localizan en la parte posterior de tu tarjeta.');
                }
            }
        }
    }, [inputCvc, inputNumberCard])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value;
            clearErrors(valu);
            reset({ valu }, {
                keepErrors: false,
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    return (
        <>
            <h1 className="h1">Editar tarjeta</h1>
            <div className="contenedorGeneral update">

                {/* <Cards
                    number={inputNumberCard}
                    name={inputTitularT}
                    expiry={expiry}
                    cvc={inputCvc}
                    focused={inputNameF}
                    placeholders={{
                        name: 'Nombre del Titular'
                    }}
                /> */}

                <form className="formCardBank" onSubmit={handleSubmit(sendFormInformacionBancaria)}>
                    {/* <p>Llena los siguientes datos tal cual aparecen en tu tarjeta.</p> */}

                    <InputTypeAndroid
                        type="text"
                        name="cardNumber"
                        id="cardNumber"
                        placeholder="Número de la tarjeta"
                        refs={register(valNumero)}
                        autocomplete='credit-card'
                        setNumero={setInputNumberCard}
                        numero={inputNumberCard}
                        readonly="readonly"
                        value={inputNumberCard}
                        errorMessage={errors.cardNumber && errors.cardNumber.message}
                        pattern={'number'}
                        minLength={lengthPan}
                        maxLength={lengthPan}
                        max="9999999999999"
                        focus={handleFocusChange}
                        // click={() => resetErrors('cardNumber')}
                    />
                    <InputTypeAndroid
                        type="text"
                        name="titular"
                        id="titular"
                        placeholder="Nombre completo del titular"
                        refs={register(valTitular)}
                        autocomplete='titular'
                        setNumero={setInputTitularT}
                        numero={inputTitularT}
                        value={inputTitularT}
                        errorMessage={errors.titular && errors.titular.message}
                        pattern={'textOnly'}
                        focus={handleFocusChange}
                        // click={() => resetErrors('titular')}
                    />

                    <label className="textDate">Fecha de vencimiento</label>
                    <div className="grupoSelect">
                        <SelectType className="w25"
                            type="text"
                            name="mes"
                            id="mes"
                            placeholder="Mes"
                            refs={register(valMes)}
                            options={meses}
                            errorMessage={errors.mes && errors.mes.message}
                            change={onChangeMes}
                        />

                        <SelectType className="w25"
                            type="text"
                            name="anio"
                            id="anio"
                            placeholder="Año"
                            refs={register(valAnio)}
                            options={anios}
                            errorMessage={errors.anio && errors.anio.message}
                            change={onChangeAnio} />
                    </div>

                    <div className="boxBtnFinalizar">
                        <button className="btnFinalizarCard">Continuar</button>
                    </div>
                </form>
            </div>
        </>
    )
}